import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Paper from '@material-ui/core/Paper';
import ScheduleDailyView from './ScheduleDailyView';
import ScheduleWeeklyView from './ScheduleWeeklyView';

const styles = theme => ({
  root: {
    padding: theme.spacing(4),
    backgroundColor: theme.palette.facet.accentBlue5,
    height: '100%',
    overflow: 'scroll',
  },
});

const ScheduleSection = ({
  className,
  classes,
  onDateChange,
  handleIncrementDate,
  handleIncrementWeek,
  handleDecrementDate,
  handleDecrementWeek,
  handleResetDate,
  date,
  actionItemLinkCount,
  displayDailyView,
  toggleDailyView,
  weeklyMeetingCollection,
  meetingCollectionLoading,
  weeklyMeetingCollectionLoading,
  ...rest
}) => {
  const { meetingCollection = [], meetingResource } = rest;
  return (
    <Paper elevation={3} square className={classNames(classes.root, className)}>
      {displayDailyView ? (
        <ScheduleDailyView
          actionItemLinkCount={actionItemLinkCount}
          date={date}
          handleDecrementDate={handleDecrementDate}
          handleIncrementDate={handleIncrementDate}
          handleResetDate={handleResetDate}
          meetingCollection={meetingCollection}
          meetingResource={meetingResource}
          handleToggleDailyView={toggleDailyView}
          meetingCollectionLoading={meetingCollectionLoading}
          {...rest}
        />
      ) : (
        <ScheduleWeeklyView
          date={date}
          handleDecrementDate={handleDecrementWeek}
          handleIncrementDate={handleIncrementWeek}
          handleResetDate={handleResetDate}
          handleToggleDailyView={toggleDailyView}
          meetingCollection={weeklyMeetingCollection || []}
          weeklyMeetingCollectionLoading={weeklyMeetingCollectionLoading}
        />
      )}
    </Paper>
  );
};

ScheduleSection.defaultProps = {
  className: '',
  meetingResource: null,
  onDateChange: () => {},
  weeklyMeetingCollectionLoading: false,
  weeklyMeetingCollection: null,
  updateActionItem: undefined,
  householdResource: null,
  getCalendarEvents: undefined,
};

ScheduleSection.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  getCalendarEvents: PropTypes.func,
  plannerActionItems: PropTypes.array.isRequired,
  clientActionItems: PropTypes.array.isRequired,
  householdResource: PropTypes.object,
  meetingResource: PropTypes.object,
  updateActionItem: PropTypes.func,
  setClientActionItems: PropTypes.func.isRequired,
  setPlannerActionItems: PropTypes.func.isRequired,
  refreshActionItems: PropTypes.func.isRequired,
  onDateChange: PropTypes.func,
  actionItemLinkCount: PropTypes.object.isRequired,
  handleDecrementDate: PropTypes.func.isRequired,
  handleDecrementWeek: PropTypes.func.isRequired,
  handleIncrementDate: PropTypes.func.isRequired,
  handleIncrementWeek: PropTypes.func.isRequired,
  handleResetDate: PropTypes.func.isRequired,
  date: PropTypes.object.isRequired,
  displayDailyView: PropTypes.bool.isRequired,
  toggleDailyView: PropTypes.func.isRequired,
  weeklyMeetingCollection: PropTypes.array,
  weeklyMeetingCollectionLoading: PropTypes.bool,
  meetingCollectionLoading: PropTypes.bool.isRequired,
};


export default withStyles(styles)(ScheduleSection);
